<h2 mat-dialog-title class="title-small">Edit Station</h2>
<mat-dialog-content class="mat-typography" style="padding-top: 10px;">
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">

        <div class="full-width" fxLayout="column" fxLayoutGap="7px">
            <span class="body-1-regular-2" style="font-size: 11px;">Station Name</span>
            <mat-form-field appearance="outline" class="custom-select-field" style="width: 100%;">
                <input matInput formControlName="name" placeholder="Enter station name">
                <mat-error *ngIf="form.get('name')?.hasError('required')">
                    Name is required
                </mat-error>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="16px">
            <div fxFlex fxLayout="column" fxLayoutGap="7px">
                <span class="body-1-regular-2" style="font-size: 11px;">Category</span>
                <mat-form-field appearance="outline" class="custom-select-field" style="width: 100%;">
                    <mat-select formControlName="category">
                        <mat-option *ngFor="let cat of categories" [value]="cat">{{ cat }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('category')?.hasError('required')">
                        Required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 16px 24px;">
    <button mat-button (click)="onCancel()" class="body-1-regular-2">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid">Update Station</button>
</mat-dialog-actions>
